<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <p class="mb-20">{{ languages.delCoolMsg1 }}</p>
    <p class="mb-20">
      {{ languages.delCoolMsg2 }}
    </p>
    <p class="mb-20">
      {{ languages.delCoolMsg3 }}
    </p>
    <div>
      <van-radio-group v-model="choose">
        <van-radio :name="1" class="mb-20">{{
          languages.delCoolConfirmYes
        }}</van-radio>
        <van-radio :name="0">{{ languages.delCoolConfirmNo }}</van-radio>
      </van-radio-group>
    </div>
    <div class="btn-wrap flex mb-60">
      <van-button class="btn" block type="info" @click="prevStep">
        {{ languages.delPrevStep }}
      </van-button>
      <van-button class="btn" block type="info" @click="handleNextStep">
        {{ languages.delNextStep }}
      </van-button>
    </div>
  </div>
</template>

<script>
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import { stepKey } from '@configs/officialSupport/accountDelete';
import accountDelete from '@mixins/officialSupport/accountDelete';
export default {
  name: 'CoolingOffChoose',
  mixins: [accountDelete],
  data() {
    return {
      choose: 1,
      compKey: stepKey.coolingOffChoose
    };
  },
  methods: {
    handleNextStep() {
      this.updateSubmitForm({
        isNeedCooling: this.choose === 1
      });
      this.nextStep();
    }
  },
  components: {
    TempInput
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
</style>
